import React from "react";
import { GolfHeaderContainer } from "../organisms/golfHeaderContainer";
import { GolfLoginContainer } from "../organisms/golfLoginContainer";
import { useMedia } from "use-media";


export const GolfLoginTemplate = (props) => {

  //レスポンシブ対応
  const isWidePhone = useMedia({ maxWidth: "480px" });
  const isWideTablet = useMedia({ maxWidth: "960px" });

  return (
    <div style={isWideTablet ? styles.loginWrapSp : styles.loginWrapPc}>
      <GolfHeaderContainer Label categoryLabel1={"ログイン"} categoryLabel2={"LOGIN"} confirmCheck={false}/>
      <GolfLoginContainer />
    </div>
  );
}

const styles = {
  loginWrapPc: {
    height: "100vh",
    overflow: "hidden",
  },
  loginWrapSp: {
    height: "100vh",
  },
}
export default GolfLoginTemplate;
